<template>
  <div class="affects-tenders">
    <template v-if="tenders.length">
      <div>{{ $t('The following tenders will be updated and contractors will be notified') }}:</div>
      <ul v-for="(tender, idx) in tenders" :key="idx">
        <AffectsOffersList :tender="tender" />
      </ul>
    </template>
    <template v-else>
      {{ $t('These changes don’t affect any tenders or contractors.') }}
    </template>
  </div>
</template>

<script>
  import AffectsOffersList from '@/components/project/history/AffectsOffersList';

  export default {
    name: 'AffectsTenders',
    components: {
      AffectsOffersList,
    },
    props: {
      tenders: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  ul {
    padding-left: 20px;
  }

  .affects-tenders {
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    color: $grey600;
  }
</style>
